
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { Client } from "@/model/Client";
    import { NoteOptions } from "@/model/pagePartOptions/NoteOptions";

    @Component({})
    export default class NotePart extends Vue {

        // mounted(): void {
        // }

        @Prop({ default: new NoteOptions() })
        options!: NoteOptions;

        @Prop({ default: false })
        isAdminView!: boolean;

        // in admin view, this will be set according to briefing - otherwise will come from Vuex store (from URL)
        @Prop({ default: null })
        client!: Client|null;

        get colour(): string { 
            const grey = "#888";
            if(!this.options.clientColourField) return grey;
            const client = this.client ?? this.$store.state.clientSettings?.client;
            if(!client) return grey;
            const field = this.options.clientColourField;
            if(!field) return grey;
            return client[field] ?? grey;
        }
    }
